var ye = Object.defineProperty;
var Ne = (e, t, r) => t in e ? ye(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var G = (e, t, r) => (Ne(e, typeof t != "symbol" ? t + "" : t, r), r);
import { useQuery as T, useMutation as fe } from "@tanstack/react-query";
import { ResponseStatus as H, IsomorphicFetch as Le, ApiError as D, StatusCodeLookup as Ce } from "@inflearn/datasource-rest";
var ve = typeof global == "object" && global && global.Object === Object && global;
const le = ve;
var Ue = typeof self == "object" && self && self.Object === Object && self, Re = le || Ue || Function("return this")();
const _e = Re;
var Se = _e.Symbol;
const j = Se;
var de = Object.prototype, De = de.hasOwnProperty, we = de.toString, m = j ? j.toStringTag : void 0;
function je(e) {
  var t = De.call(e, m), r = e[m];
  try {
    e[m] = void 0;
    var o = !0;
  } catch {
  }
  var n = we.call(e);
  return o && (t ? e[m] = r : delete e[m]), n;
}
var Pe = Object.prototype, Me = Pe.toString;
function Ve(e) {
  return Me.call(e);
}
var Fe = "[object Null]", Ge = "[object Undefined]", W = j ? j.toStringTag : void 0;
function C(e) {
  return e == null ? e === void 0 ? Ge : Fe : W && W in Object(e) ? je(e) : Ve(e);
}
function v(e) {
  return e != null && typeof e == "object";
}
var He = "[object Symbol]";
function Be(e) {
  return typeof e == "symbol" || v(e) && C(e) == He;
}
function Ke(e, t) {
  for (var r = -1, o = e == null ? 0 : e.length, n = Array(o); ++r < o; )
    n[r] = t(e[r], r, e);
  return n;
}
var $e = Array.isArray;
const Ee = $e;
var ke = /\s/;
function xe(e) {
  for (var t = e.length; t-- && ke.test(e.charAt(t)); )
    ;
  return t;
}
var ze = /^\s+/;
function Qe(e) {
  return e && e.slice(0, xe(e) + 1).replace(ze, "");
}
function $(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Z = 0 / 0, Ye = /^[-+]0x[0-9a-f]+$/i, Xe = /^0b[01]+$/i, qe = /^0o[0-7]+$/i, We = parseInt;
function Ze(e) {
  if (typeof e == "number")
    return e;
  if (Be(e))
    return Z;
  if ($(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = $(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Qe(e);
  var r = Xe.test(e);
  return r || qe.test(e) ? We(e.slice(2), r ? 2 : 8) : Ye.test(e) ? Z : +e;
}
var J = 1 / 0, Je = 17976931348623157e292;
function et(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Ze(e), e === J || e === -J) {
    var t = e < 0 ? -1 : 1;
    return t * Je;
  }
  return e === e ? e : 0;
}
function tt(e) {
  var t = et(e), r = t % 1;
  return t === t ? r ? t - r : t : 0;
}
function rt(e) {
  return e;
}
var nt = "[object AsyncFunction]", ot = "[object Function]", at = "[object GeneratorFunction]", st = "[object Proxy]";
function it(e) {
  if (!$(e))
    return !1;
  var t = C(e);
  return t == ot || t == at || t == nt || t == st;
}
function ct(e) {
  return function() {
    return e;
  };
}
function ut(e, t, r, o) {
  for (var n = e.length, a = r + (o ? 1 : -1); o ? a-- : ++a < n; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
function ft(e) {
  return e !== e;
}
function lt(e, t, r) {
  for (var o = r - 1, n = e.length; ++o < n; )
    if (e[o] === t)
      return o;
  return -1;
}
function _t(e, t, r) {
  return t === t ? lt(e, t, r) : ut(e, ft, r);
}
var dt = 9007199254740991, Et = /^(?:0|[1-9]\d*)$/;
function Ot(e, t) {
  var r = typeof e;
  return t = t ?? dt, !!t && (r == "number" || r != "symbol" && Et.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Tt = 9007199254740991;
function Oe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Tt;
}
function Te(e) {
  return e != null && Oe(e.length) && !it(e);
}
var pt = Object.prototype;
function bt(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || pt;
  return e === r;
}
function At(e, t) {
  for (var r = -1, o = Array(e); ++r < e; )
    o[r] = t(r);
  return o;
}
var It = "[object Arguments]";
function ee(e) {
  return v(e) && C(e) == It;
}
var pe = Object.prototype, gt = pe.hasOwnProperty, ht = pe.propertyIsEnumerable, mt = ee(function() {
  return arguments;
}()) ? ee : function(e) {
  return v(e) && gt.call(e, "callee") && !ht.call(e, "callee");
};
const yt = mt;
function Nt() {
  return !1;
}
var be = typeof exports == "object" && exports && !exports.nodeType && exports, te = be && typeof module == "object" && module && !module.nodeType && module, Lt = te && te.exports === be, re = Lt ? _e.Buffer : void 0, Ct = re ? re.isBuffer : void 0, vt = Ct || Nt;
const Ut = vt;
var Rt = "[object Arguments]", St = "[object Array]", Dt = "[object Boolean]", wt = "[object Date]", jt = "[object Error]", Pt = "[object Function]", Mt = "[object Map]", Vt = "[object Number]", Ft = "[object Object]", Gt = "[object RegExp]", Ht = "[object Set]", Bt = "[object String]", Kt = "[object WeakMap]", $t = "[object ArrayBuffer]", kt = "[object DataView]", xt = "[object Float32Array]", zt = "[object Float64Array]", Qt = "[object Int8Array]", Yt = "[object Int16Array]", Xt = "[object Int32Array]", qt = "[object Uint8Array]", Wt = "[object Uint8ClampedArray]", Zt = "[object Uint16Array]", Jt = "[object Uint32Array]", _ = {};
_[xt] = _[zt] = _[Qt] = _[Yt] = _[Xt] = _[qt] = _[Wt] = _[Zt] = _[Jt] = !0;
_[Rt] = _[St] = _[$t] = _[Dt] = _[kt] = _[wt] = _[jt] = _[Pt] = _[Mt] = _[Vt] = _[Ft] = _[Gt] = _[Ht] = _[Bt] = _[Kt] = !1;
function er(e) {
  return v(e) && Oe(e.length) && !!_[C(e)];
}
function tr(e) {
  return function(t) {
    return e(t);
  };
}
var Ae = typeof exports == "object" && exports && !exports.nodeType && exports, y = Ae && typeof module == "object" && module && !module.nodeType && module, rr = y && y.exports === Ae, B = rr && le.process, nr = function() {
  try {
    var e = y && y.require && y.require("util").types;
    return e || B && B.binding && B.binding("util");
  } catch {
  }
}();
const ne = nr;
var oe = ne && ne.isTypedArray, or = oe ? tr(oe) : er;
const ar = or;
var sr = Object.prototype, ir = sr.hasOwnProperty;
function cr(e, t) {
  var r = Ee(e), o = !r && yt(e), n = !r && !o && Ut(e), a = !r && !o && !n && ar(e), d = r || o || n || a, i = d ? At(e.length, String) : [], l = i.length;
  for (var s in e)
    (t || ir.call(e, s)) && !(d && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    n && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    Ot(s, l))) && i.push(s);
  return i;
}
function ur(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var fr = ur(Object.keys, Object);
const lr = fr;
var _r = Object.prototype, dr = _r.hasOwnProperty;
function Er(e) {
  if (!bt(e))
    return lr(e);
  var t = [];
  for (var r in Object(e))
    dr.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
function Ie(e) {
  return Te(e) ? cr(e) : Er(e);
}
function Or(e) {
  return function(t, r, o) {
    for (var n = -1, a = Object(t), d = o(t), i = d.length; i--; ) {
      var l = d[e ? i : ++n];
      if (r(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var Tr = Or();
const pr = Tr;
function br(e, t) {
  return e && pr(e, t, Ie);
}
var Ar = "[object String]";
function Ir(e) {
  return typeof e == "string" || !Ee(e) && v(e) && C(e) == Ar;
}
function gr(e, t) {
  return Ke(t, function(r) {
    return e[r];
  });
}
function hr(e) {
  return e == null ? [] : gr(e, Ie(e));
}
var mr = Math.max;
function yr(e, t, r, o) {
  e = Te(e) ? e : hr(e), r = r && !o ? tt(r) : 0;
  var n = e.length;
  return r < 0 && (r = mr(n + r, 0)), Ir(e) ? r <= n && e.indexOf(t, r) > -1 : !!n && _t(e, t, r) > -1;
}
function Nr(e, t, r, o) {
  return br(e, function(n, a, d) {
    t(o, r(n), a, d);
  }), o;
}
function Lr(e, t) {
  return function(r, o) {
    return Nr(r, e, t(o), {});
  };
}
var Cr = Object.prototype, vr = Cr.toString, Ur = Lr(function(e, t, r) {
  t != null && typeof t.toString != "function" && (t = vr.call(t)), e[t] = r;
}, ct(rt));
const Rr = Ur, Sr = {
  MODE: "development",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "https://www.devinflearn.com",
  SITE_URL: "https://www.devinflearn.com",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "https://business.devinflearn.com",
  ADMIN_DOMAIN: "https://admin.devinflearn.com",
  COOKIE_DOMAIN: ".devinflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, Dr = {
  MODE: "localhost",
  CDN_URL: "https://cdn.devinflearn.com",
  API_URL: "http://localhost:3000",
  SITE_URL: "http://localhost:3000",
  MENTORING_SITE_URL: "https://mentoring.devinflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.devinflearn.com",
  ACCOUNT_API_URL: "https://account-api.devinflearn.com",
  COURSE_API_URL: "https://course-api.devinflearn.com",
  UCC_API_URL: "https://ucc-api.devinflearn.com",
  RALLIT_SITE_URL: "https://www.devrallit.com",
  BUSINESS_DOMAIN: "http://localhost:7020",
  ADMIN_DOMAIN: "http://localhost:7010",
  COOKIE_DOMAIN: "localhost",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.test",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "65fef69e7b3b778bd124",
  OAUTH_GITHUB_CLIENT_ID: "41f342acfada922e9fb5",
  OAUTH_GOOGLE_CLIENT_ID: "333892070963-abo0eoss3ielmeukj8dtvpr4l0fbniun.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "1281a93457d30e1f2ffafe9fe0c197ab",
  HACKLE_BROWSER_SDK_KEY: "ygFNanOzYS2M5JgfrE5gUk69EbkFIzZ4",
  MIXPANEL_TOKEN: "2df837e504078b475f90b32d9a268c01",
  CDN_INTEGRATION_URL: "https://cdn.devinflab.com"
}, ae = {
  MODE: "production",
  CDN_URL: "https://cdn.inflearn.com",
  API_URL: "https://www.inflearn.com",
  SITE_URL: "https://www.inflearn.com",
  MENTORING_SITE_URL: "https://mentoring.inflearn.com",
  SOCIAL_ACCOUNT_URL: "https://account.inflearn.com",
  ACCOUNT_API_URL: "https://account-api.inflearn.com",
  COURSE_API_URL: "https://course-api.inflearn.com",
  UCC_API_URL: "https://ucc-api.inflearn.com",
  RALLIT_SITE_URL: "https://www.rallit.com",
  BUSINESS_DOMAIN: "https://business.inflearn.com",
  ADMIN_DOMAIN: "https://admin.inflearn.com",
  COOKIE_DOMAIN: ".inflearn.com",
  OAUTH_APPLE_CLIENT_ID: "com.inflab.inflearn.web",
  OAUTH_GITHUB_CLIENT_ID_LEGACY: "5fd8e44b142806d9cbea",
  OAUTH_GITHUB_CLIENT_ID: "419780d6d3750d84d1db",
  OAUTH_GOOGLE_CLIENT_ID: "887875630717-ror9t8ig4obhvokdij07eoochpqbu5kf.apps.googleusercontent.com",
  OAUTH_KAKAO_REST_ID: "0de1184063abadc9cef9dbf417c567a5",
  HACKLE_BROWSER_SDK_KEY: "rb1wDPCB39swIGfTAhDcz0QXvmh6hayS",
  MIXPANEL_TOKEN: "c05d8cc017a29af05e50c0d43d848d2d",
  CDN_INTEGRATION_URL: "https://cdn.inflab.com"
};
function wr() {
  return typeof window < "u" && (window != null && window.env) ? window.env : process.env.NEXT_PUBLIC_ENV || process.env.APP_ENV;
}
function jr() {
  const e = wr();
  return e ? e === "localhost" ? Dr : e === "production" ? ae : Sr : (console.error("app-shell env is not defined"), ae);
}
const E = jr(), Sn = E.CDN_URL, Dn = E.SITE_URL, wn = E.MENTORING_SITE_URL, jn = E.SOCIAL_ACCOUNT_URL, Pr = E.API_URL, Mr = `${Pr}/api`, Vr = E.ACCOUNT_API_URL, Fr = E.COURSE_API_URL, Gr = E.UCC_API_URL, Hr = E.MODE, Pn = E.RALLIT_SITE_URL, Mn = E.OAUTH_APPLE_CLIENT_ID, Vn = E.OAUTH_GITHUB_CLIENT_ID, Fn = E.OAUTH_GOOGLE_CLIENT_ID, Gn = E.OAUTH_KAKAO_REST_ID, Hn = E.BUSINESS_DOMAIN, Bn = E.COOKIE_DOMAIN, Kn = E.HACKLE_BROWSER_SDK_KEY, $n = E.MIXPANEL_TOKEN, kn = E.CDN_INTEGRATION_URL, xn = Hr !== "production";
var zn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Br(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Qn(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function o() {
      if (this instanceof o) {
        var n = [null];
        n.push.apply(n, arguments);
        var a = Function.bind.apply(t, n);
        return new a();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", {
    value: !0
  }), Object.keys(e).forEach(function(o) {
    var n = Object.getOwnPropertyDescriptor(e, o);
    Object.defineProperty(r, o, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[o];
      }
    });
  }), r;
}
var M = { exports: {} };
function Kr(e) {
  try {
    return JSON.stringify(e);
  } catch {
    return '"[Circular]"';
  }
}
var $r = kr;
function kr(e, t, r) {
  var o = r && r.stringify || Kr, n = 1;
  if (typeof e == "object" && e !== null) {
    var a = t.length + n;
    if (a === 1)
      return e;
    var d = new Array(a);
    d[0] = o(e);
    for (var i = 1; i < a; i++)
      d[i] = o(t[i]);
    return d.join(" ");
  }
  if (typeof e != "string")
    return e;
  var l = t.length;
  if (l === 0)
    return e;
  for (var s = "", c = 1 - n, f = -1, p = e && e.length || 0, u = 0; u < p; ) {
    if (e.charCodeAt(u) === 37 && u + 1 < p) {
      switch (f = f > -1 ? f : 0, e.charCodeAt(u + 1)) {
        case 100:
        case 102:
          if (c >= l || t[c] == null)
            break;
          f < u && (s += e.slice(f, u)), s += Number(t[c]), f = u + 2, u++;
          break;
        case 105:
          if (c >= l || t[c] == null)
            break;
          f < u && (s += e.slice(f, u)), s += Math.floor(Number(t[c])), f = u + 2, u++;
          break;
        case 79:
        case 111:
        case 106:
          if (c >= l || t[c] === void 0)
            break;
          f < u && (s += e.slice(f, u));
          var R = typeof t[c];
          if (R === "string") {
            s += "'" + t[c] + "'", f = u + 2, u++;
            break;
          }
          if (R === "function") {
            s += t[c].name || "<anonymous>", f = u + 2, u++;
            break;
          }
          s += o(t[c]), f = u + 2, u++;
          break;
        case 115:
          if (c >= l)
            break;
          f < u && (s += e.slice(f, u)), s += String(t[c]), f = u + 2, u++;
          break;
        case 37:
          f < u && (s += e.slice(f, u)), s += "%", f = u + 2, u++, c--;
          break;
      }
      ++c;
    }
    ++u;
  }
  return f === -1 ? e : (f < p && (s += e.slice(f)), s);
}
const se = $r;
M.exports = b;
const N = an().console || {}, xr = {
  mapHttpRequest: w,
  mapHttpResponse: w,
  wrapRequestSerializer: K,
  wrapResponseSerializer: K,
  wrapErrorSerializer: K,
  req: w,
  res: w,
  err: ce,
  errWithCause: ce
};
function P(e, t) {
  return e === "silent" ? 1 / 0 : t.levels.values[e];
}
const z = Symbol("pino.logFuncs"), k = Symbol("pino.hierarchy"), zr = {
  error: "log",
  fatal: "error",
  warn: "error",
  info: "log",
  debug: "log",
  trace: "log"
};
function ie(e, t) {
  const r = {
    logger: t,
    parent: e[k]
  };
  t[k] = r;
}
function Qr(e, t, r) {
  const o = {};
  t.forEach((n) => {
    o[n] = r[n] ? r[n] : N[n] || N[zr[n] || "log"] || L;
  }), e[z] = o;
}
function Yr(e, t) {
  return Array.isArray(e) ? e.filter(function(o) {
    return o !== "!stdSerializers.err";
  }) : e === !0 ? Object.keys(t) : !1;
}
function b(e) {
  e = e || {}, e.browser = e.browser || {};
  const t = e.browser.transmit;
  if (t && typeof t.send != "function")
    throw Error("pino: transmit option must have a send function");
  const r = e.browser.write || N;
  e.browser.write && (e.browser.asObject = !0);
  const o = e.serializers || {}, n = Yr(e.browser.serialize, o);
  let a = e.browser.serialize;
  Array.isArray(e.browser.serialize) && e.browser.serialize.indexOf("!stdSerializers.err") > -1 && (a = !1);
  const d = Object.keys(e.customLevels || {}), i = ["error", "fatal", "warn", "info", "debug", "trace"].concat(d);
  typeof r == "function" && i.forEach(function(O) {
    r[O] = r;
  }), (e.enabled === !1 || e.browser.disabled) && (e.level = "silent");
  const l = e.level || "info", s = Object.create(r);
  s.log || (s.log = L), Qr(s, i, r), ie({}, s), Object.defineProperty(s, "levelVal", {
    get: f
  }), Object.defineProperty(s, "level", {
    get: p,
    set: u
  });
  const c = {
    transmit: t,
    serialize: n,
    asObject: e.browser.asObject,
    formatters: e.browser.formatters,
    levels: i,
    timestamp: rn(e)
  };
  s.levels = Xr(e), s.level = l, s.setMaxListeners = s.getMaxListeners = s.emit = s.addListener = s.on = s.prependListener = s.once = s.prependOnceListener = s.removeListener = s.removeAllListeners = s.listeners = s.listenerCount = s.eventNames = s.write = s.flush = L, s.serializers = o, s._serialize = n, s._stdErrSerialize = a, s.child = R, t && (s._logEvent = x());
  function f() {
    return P(this.level, this);
  }
  function p() {
    return this._level;
  }
  function u(O) {
    if (O !== "silent" && !this.levels.values[O])
      throw Error("unknown level " + O);
    this._level = O, A(this, c, s, "error"), A(this, c, s, "fatal"), A(this, c, s, "warn"), A(this, c, s, "info"), A(this, c, s, "debug"), A(this, c, s, "trace"), d.forEach((g) => {
      A(this, c, s, g);
    });
  }
  function R(O, g) {
    if (!O)
      throw new Error("missing bindings for child Pino");
    g = g || {}, n && O.serializers && (g.serializers = O.serializers);
    const Q = g.serializers;
    if (n && Q) {
      var S = Object.assign({}, o, Q), Y = e.browser.serialize === !0 ? Object.keys(S) : n;
      delete O.serializers, V([O], Y, S, this._stdErrSerialize);
    }
    function X(q) {
      this._childLevel = (q._childLevel | 0) + 1, this.bindings = O, S && (this.serializers = S, this._serialize = Y), t && (this._logEvent = x(
        [].concat(q._logEvent.bindings, O)
      ));
    }
    X.prototype = this;
    const F = new X(this);
    return ie(this, F), F.level = this.level, F;
  }
  return s;
}
function Xr(e) {
  const t = e.customLevels || {}, r = Object.assign({}, b.levels.values, t), o = Object.assign({}, b.levels.labels, qr(t));
  return {
    values: r,
    labels: o
  };
}
function qr(e) {
  const t = {};
  return Object.keys(e).forEach(function(r) {
    t[e[r]] = r;
  }), t;
}
b.levels = {
  values: {
    fatal: 60,
    error: 50,
    warn: 40,
    info: 30,
    debug: 20,
    trace: 10
  },
  labels: {
    10: "trace",
    20: "debug",
    30: "info",
    40: "warn",
    50: "error",
    60: "fatal"
  }
};
b.stdSerializers = xr;
b.stdTimeFunctions = Object.assign({}, { nullTime: ge, epochTime: he, unixTime: nn, isoTime: on });
function Wr(e) {
  const t = [];
  e.bindings && t.push(e.bindings);
  let r = e[k];
  for (; r.parent; )
    r = r.parent, r.logger.bindings && t.push(r.logger.bindings);
  return t.reverse();
}
function A(e, t, r, o) {
  if (Object.defineProperty(e, o, {
    value: P(e.level, r) > P(o, r) ? L : r[z][o],
    writable: !0,
    enumerable: !0,
    configurable: !0
  }), !t.transmit && e[o] === L)
    return;
  e[o] = Jr(e, t, r, o);
  const n = Wr(e);
  n.length !== 0 && (e[o] = Zr(n, e[o]));
}
function Zr(e, t) {
  return function() {
    return t.apply(this, [...e, ...arguments]);
  };
}
function Jr(e, t, r, o) {
  return function(n) {
    return function() {
      const d = t.timestamp(), i = new Array(arguments.length), l = Object.getPrototypeOf && Object.getPrototypeOf(this) === N ? N : this;
      for (var s = 0; s < i.length; s++)
        i[s] = arguments[s];
      if (t.serialize && !t.asObject && V(i, this._serialize, this.serializers, this._stdErrSerialize), t.asObject || t.formatters ? n.call(l, en(this, o, i, d, t.formatters)) : n.apply(l, i), t.transmit) {
        const c = t.transmit.level || e._level, f = r.levels.values[c], p = r.levels.values[o];
        if (p < f)
          return;
        tn(this, {
          ts: d,
          methodLevel: o,
          methodValue: p,
          transmitLevel: c,
          transmitValue: r.levels.values[t.transmit.level || e._level],
          send: t.transmit.send,
          val: P(e._level, r)
        }, i);
      }
    };
  }(e[z][o]);
}
function en(e, t, r, o, n = {}) {
  const {
    level: a = () => e.levels.values[t],
    log: d = (p) => p
  } = n;
  e._serialize && V(r, e._serialize, e.serializers, e._stdErrSerialize);
  const i = r.slice();
  let l = i[0];
  const s = {};
  o && (s.time = o), s.level = a(t, e.levels.values[t]);
  let c = (e._childLevel | 0) + 1;
  if (c < 1 && (c = 1), l !== null && typeof l == "object") {
    for (; c-- && typeof i[0] == "object"; )
      Object.assign(s, i.shift());
    l = i.length ? se(i.shift(), i) : void 0;
  } else
    typeof l == "string" && (l = se(i.shift(), i));
  return l !== void 0 && (s.msg = l), d(s);
}
function V(e, t, r, o) {
  for (const n in e)
    if (o && e[n] instanceof Error)
      e[n] = b.stdSerializers.err(e[n]);
    else if (typeof e[n] == "object" && !Array.isArray(e[n]))
      for (const a in e[n])
        t && t.indexOf(a) > -1 && a in r && (e[n][a] = r[a](e[n][a]));
}
function tn(e, t, r) {
  const o = t.send, n = t.ts, a = t.methodLevel, d = t.methodValue, i = t.val, l = e._logEvent.bindings;
  V(
    r,
    e._serialize || Object.keys(e.serializers),
    e.serializers,
    e._stdErrSerialize === void 0 ? !0 : e._stdErrSerialize
  ), e._logEvent.ts = n, e._logEvent.messages = r.filter(function(s) {
    return l.indexOf(s) === -1;
  }), e._logEvent.level.label = a, e._logEvent.level.value = d, o(a, e._logEvent, i), e._logEvent = x(l);
}
function x(e) {
  return {
    ts: 0,
    messages: [],
    bindings: e || [],
    level: { label: "", value: 0 }
  };
}
function ce(e) {
  const t = {
    type: e.constructor.name,
    msg: e.message,
    stack: e.stack
  };
  for (const r in e)
    t[r] === void 0 && (t[r] = e[r]);
  return t;
}
function rn(e) {
  return typeof e.timestamp == "function" ? e.timestamp : e.timestamp === !1 ? ge : he;
}
function w() {
  return {};
}
function K(e) {
  return e;
}
function L() {
}
function ge() {
  return !1;
}
function he() {
  return Date.now();
}
function nn() {
  return Math.round(Date.now() / 1e3);
}
function on() {
  return new Date(Date.now()).toISOString();
}
function an() {
  function e(t) {
    return typeof t < "u" && t;
  }
  try {
    return typeof globalThis < "u" || Object.defineProperty(Object.prototype, "globalThis", {
      get: function() {
        return delete Object.prototype.globalThis, this.globalThis = this;
      },
      configurable: !0
    }), globalThis;
  } catch {
    return e(self) || e(window) || e(this) || {};
  }
}
M.exports.default = b;
M.exports.pino = b;
var sn = M.exports;
const cn = /* @__PURE__ */ Br(sn);
class un {
  constructor() {
    G(this, "logger");
    /**
     * 서버와 log level을 동기화 하기 위한 설정
     * @see {@link https://github.com/winstonjs/winston#logging-levels Winston log level}
     */
    G(this, "defaultLogLevelMap");
    this.defaultLogLevelMap = {
      error: 3,
      warn: 4,
      info: 6,
      debug: 7
    }, this.logger = cn(), this.logger.levels = {
      labels: Rr(this.defaultLogLevelMap),
      values: this.defaultLogLevelMap
    };
  }
  debug(t) {
    this.log("debug", t);
  }
  info(t) {
    this.log("info", t);
  }
  warn(t) {
    this.log("warn", t);
  }
  error(t) {
    this.log("error", t);
  }
  log(t, r) {
    if (this.isLogLevelKey(t)) {
      this.logger[t](r);
      return;
    }
    const o = this.findLoggerTypeForSyslogLevel(t);
    o && this.logger[o](r);
  }
  isLogLevelKey(t) {
    return typeof t == "string" && yr(Object.keys(this.defaultLogLevelMap), t);
  }
  findLoggerTypeForSyslogLevel(t) {
    const r = this.logger.levels.labels[t];
    return this.isLogLevelKey(r) ? r : null;
  }
}
const ue = new un(), fn = 10 * 1e3, ln = [H.NOT_FOUND, H.UNAUTHORIZED, H.BAD_PARAMETER];
class h extends Le {
  static from(t) {
    return new h({
      credentials: "include",
      timeout: fn,
      ...t
    });
  }
  afterRequest(t, r, o, n) {
    if (D.isHandledResponse(n)) {
      const a = D.createApiError(n, {
        status: t,
        handled: !0,
        extra: n,
        url: o.path
      }), {
        level: d,
        message: i
      } = a.logMessage();
      throw ue[d](i), a;
    }
    return n;
  }
  performError(t) {
    if (t instanceof DOMException && t.name === "AbortError") {
      console.error(`[CustomAbortError] ${t.message} *release: ${window.__RELEASE__}`);
      return;
    }
    if (D.isUnhandledResponse(t)) {
      const r = D.createApiError({
        statusCode: Ce[t.status] || String(t.status),
        message: `[${t.name}] ${t.url} | ${t}`,
        data: null
      }, {
        handled: !1,
        url: t.url,
        status: t.status
      }, ln), {
        level: o,
        message: n
      } = r.logMessage();
      ue[o](n);
    }
  }
}
const U = h.from({
  baseUrl: Mr
}), _n = h.from({
  baseUrl: Vr
}), dn = h.from({
  baseUrl: Fr
}), Yn = h.from({
  baseUrl: Gr
});
var En = /* @__PURE__ */ ((e) => (e.OK = "OK", e.SERVER_ERROR = "SERVER_ERROR", e.DUPLICATE = "DUPLICATE", e.NOT_FOUND = "NOT_FOUND", e.BAD_REQUEST = "BAD_REQUEST", e.BAD_PARAMETER = "BAD_PARAMETER", e.CONFLICT = "CONFLICT", e.UNAUTHORIZED = "UNAUTHORIZED", e.FORBIDDEN = "FORBIDDEN", e.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", e.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", e))(En || {});
const Xn = {
  V1_MESSAGE: "/user/api/v1/messages/unchecked",
  V1_USER_META: "/v1/user/meta",
  V1_GROUP_BY_USER: "/v1/group/by-user",
  V1_GROUP_ID_NOTICE_EXPOSURE: (e) => `/v1/group/${e}/notice/exposure`,
  V1_NOTICE_EXPOSURE: "/v1/notice/exposure"
}, On = async (e, t) => U.get(e, t);
function qn({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => On(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const Tn = async (e, t) => U.get(e, t);
function Wn({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => Tn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const pn = async (e, t) => U.get(e, t);
function Zn({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => pn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const bn = async (e, t) => U.get(e, t);
function Jn({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => bn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const An = async (e, t) => U.get(e, t);
function eo({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => An(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const me = _n, to = {
  CLIENT_V2_ACCOUNT_PROFILE: "/client/api/v2/account/profile",
  CLIENT_V2_AUTH_SIGNIN: "/client/api/v2/auth/signin"
};
function ro({
  url: e,
  options: t,
  requestOptions: r
}) {
  var n;
  const o = fe((a) => me.post(e, a, r), t);
  return {
    ...o,
    data: (n = o.data) == null ? void 0 : n.data
  };
}
const In = async (e, t) => me.get(e, t);
function no({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => In(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const I = dn;
var gn = /* @__PURE__ */ ((e) => (e.OK = "OK", e.SERVER_ERROR = "SERVER_ERROR", e.DUPLICATE = "DUPLICATE", e.NOT_FOUND = "NOT_FOUND", e.BAD_REQUEST = "BAD_REQUEST", e.BAD_PARAMETER = "BAD_PARAMETER", e.CONFLICT = "CONFLICT", e.UNAUTHORIZED = "UNAUTHORIZED", e.FORBIDDEN = "FORBIDDEN", e.PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE", e.TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS", e))(gn || {});
const oo = {
  CLIENT_V1_CART: "/client/api/v1/cart",
  CLIENT_V1_CATEGORY_MAIN: "/client/api/v1/category/main",
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM: "/client/api/v1/course-contract-histories/inflearn-marketing-confirm",
  CLIENT_V1_COURSE_CONTRACT_HISTORIES_INFLEARN_MARKETING_CONFIRM_REQUIRED: "/client/api/v1/course-contract-histories/inflearn-marketing-confirm-required",
  CLIENT_V1_COURSE_CONTRACTS_INFLEARN_MARKETING_CONTENTS_TERM: "/client/api/v1/course-contracts/inflearn-marketing-contents-term",
  CLIENT_V1_COURSE_AUTO_COMPLETE: "/client/api/v1/course/auto-complete",
  CLIENT_V1_VOUCHERS_RECENT_LEARNING: "/client/api/v1/vouchers/recent-learning"
}, hn = async (e, t) => I.get(e, t);
function ao({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => hn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const mn = async (e, t) => I.get(e, t);
function so({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => mn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
function io({
  url: e,
  options: t,
  requestOptions: r
}) {
  var n;
  const o = fe((a) => I.post(e, a, r), t);
  return {
    ...o,
    data: (n = o.data) == null ? void 0 : n.data
  };
}
const yn = async (e, t) => I.get(e, t);
function co({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => yn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const Nn = async (e, t) => I.get(e, t);
function uo({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => Nn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const Ln = async (e, t) => I.get(e, t);
function fo({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => Ln(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
const Cn = async (e, t) => I.get(e, t);
function lo({
  queryKey: e,
  url: t,
  options: r,
  requestOptions: o
}) {
  var a;
  const n = T(e, () => Cn(t, o), r);
  return {
    ...n,
    data: (a = n.data) == null ? void 0 : a.data
  };
}
export {
  br as $,
  to as A,
  Hn as B,
  Bn as C,
  Pn as D,
  $n as E,
  Sn as F,
  fo as G,
  Kn as H,
  oo as I,
  so as J,
  zn as K,
  Qn as L,
  Hr as M,
  Mr as N,
  Gn as O,
  Vr as P,
  Pr as Q,
  En as R,
  jn as S,
  Xn as T,
  Yn as U,
  j as V,
  Ke as W,
  Be as X,
  _t as Y,
  Ie as Z,
  Oe as _,
  Vn as a,
  tt as a0,
  ut as a1,
  tr as a2,
  et as a3,
  Zn as a4,
  Jn as a5,
  io as a6,
  co as a7,
  uo as a8,
  Rr as a9,
  yr as aa,
  kn as ab,
  qn as ac,
  lo as ad,
  Cn as ae,
  gn as af,
  ue as ag,
  Wn as ah,
  eo as ai,
  xn as aj,
  ao as ak,
  Fn as b,
  Mn as c,
  Dn as d,
  it as e,
  rt as f,
  ct as g,
  Te as h,
  $ as i,
  Ot as j,
  bt as k,
  cr as l,
  v as m,
  C as n,
  ur as o,
  Ee as p,
  Ut as q,
  _e as r,
  ar as s,
  yt as t,
  ro as u,
  pr as v,
  Er as w,
  wn as x,
  no as y,
  Br as z
};
